"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfo = exports.setBranding = exports.deregisterSafariExtensionStatusCallback = exports.registerSafariExtensionStatusCallback = exports.deregisterStatusCallback = exports.registerStatusCallback = exports.getInstallerInfo = exports.removeDropzone = exports.createDropzone = exports.modifyTransfer = exports.showPreferences = exports.showSelectFolderDialog = exports.showSelectFileDialog = exports.deregisterRemovedCallback = exports.registerRemovedCallback = exports.getTransfer = exports.getAllTransfers = exports.resumeTransfer = exports.stopTransfer = exports.showDirectory = exports.removeTransfer = exports.deregisterActivityCallback = exports.registerActivityCallback = exports.launch = exports.startTransfer = exports.testConnection = exports.init = exports.isSafari = exports.asperaSdk = void 0;
var aspera_sdk_model_1 = require("./models/aspera-sdk.model");
var core_1 = require("./app/core");
Object.defineProperty(exports, "createDropzone", { enumerable: true, get: function () { return core_1.createDropzone; } });
Object.defineProperty(exports, "deregisterActivityCallback", { enumerable: true, get: function () { return core_1.deregisterActivityCallback; } });
Object.defineProperty(exports, "deregisterRemovedCallback", { enumerable: true, get: function () { return core_1.deregisterRemovedCallback; } });
Object.defineProperty(exports, "deregisterSafariExtensionStatusCallback", { enumerable: true, get: function () { return core_1.deregisterSafariExtensionStatusCallback; } });
Object.defineProperty(exports, "deregisterStatusCallback", { enumerable: true, get: function () { return core_1.deregisterStatusCallback; } });
Object.defineProperty(exports, "getAllTransfers", { enumerable: true, get: function () { return core_1.getAllTransfers; } });
Object.defineProperty(exports, "getInfo", { enumerable: true, get: function () { return core_1.getInfo; } });
Object.defineProperty(exports, "getTransfer", { enumerable: true, get: function () { return core_1.getTransfer; } });
Object.defineProperty(exports, "init", { enumerable: true, get: function () { return core_1.init; } });
Object.defineProperty(exports, "modifyTransfer", { enumerable: true, get: function () { return core_1.modifyTransfer; } });
Object.defineProperty(exports, "registerActivityCallback", { enumerable: true, get: function () { return core_1.registerActivityCallback; } });
Object.defineProperty(exports, "registerRemovedCallback", { enumerable: true, get: function () { return core_1.registerRemovedCallback; } });
Object.defineProperty(exports, "registerSafariExtensionStatusCallback", { enumerable: true, get: function () { return core_1.registerSafariExtensionStatusCallback; } });
Object.defineProperty(exports, "registerStatusCallback", { enumerable: true, get: function () { return core_1.registerStatusCallback; } });
Object.defineProperty(exports, "removeDropzone", { enumerable: true, get: function () { return core_1.removeDropzone; } });
Object.defineProperty(exports, "removeTransfer", { enumerable: true, get: function () { return core_1.removeTransfer; } });
Object.defineProperty(exports, "resumeTransfer", { enumerable: true, get: function () { return core_1.resumeTransfer; } });
Object.defineProperty(exports, "setBranding", { enumerable: true, get: function () { return core_1.setBranding; } });
Object.defineProperty(exports, "showDirectory", { enumerable: true, get: function () { return core_1.showDirectory; } });
Object.defineProperty(exports, "showPreferences", { enumerable: true, get: function () { return core_1.showPreferences; } });
Object.defineProperty(exports, "showSelectFileDialog", { enumerable: true, get: function () { return core_1.showSelectFileDialog; } });
Object.defineProperty(exports, "showSelectFolderDialog", { enumerable: true, get: function () { return core_1.showSelectFolderDialog; } });
Object.defineProperty(exports, "startTransfer", { enumerable: true, get: function () { return core_1.startTransfer; } });
Object.defineProperty(exports, "stopTransfer", { enumerable: true, get: function () { return core_1.stopTransfer; } });
Object.defineProperty(exports, "testConnection", { enumerable: true, get: function () { return core_1.testConnection; } });
var installer_1 = require("./app/installer");
Object.defineProperty(exports, "getInstallerInfo", { enumerable: true, get: function () { return installer_1.getInstallerInfo; } });
var helpers_1 = require("./helpers/helpers");
Object.defineProperty(exports, "isSafari", { enumerable: true, get: function () { return helpers_1.isSafari; } });
exports.asperaSdk = new aspera_sdk_model_1.AsperaSdk();
exports.asperaSdk.init = core_1.init;
exports.asperaSdk.testConnection = core_1.testConnection;
exports.asperaSdk.startTransfer = core_1.startTransfer;
exports.asperaSdk.registerActivityCallback = core_1.registerActivityCallback;
exports.asperaSdk.deregisterActivityCallback = core_1.deregisterActivityCallback;
exports.asperaSdk.removeTransfer = core_1.removeTransfer;
exports.asperaSdk.showDirectory = core_1.showDirectory;
exports.asperaSdk.stopTransfer = core_1.stopTransfer;
exports.asperaSdk.resumeTransfer = core_1.resumeTransfer;
exports.asperaSdk.getAllTransfers = core_1.getAllTransfers;
exports.asperaSdk.getTransfer = core_1.getTransfer;
exports.asperaSdk.registerRemovedCallback = core_1.registerRemovedCallback;
exports.asperaSdk.deregisterRemovedCallback = core_1.deregisterRemovedCallback;
exports.asperaSdk.showSelectFileDialog = core_1.showSelectFileDialog;
exports.asperaSdk.showSelectFolderDialog = core_1.showSelectFolderDialog;
exports.asperaSdk.showPreferences = core_1.showPreferences;
exports.asperaSdk.modifyTransfer = core_1.modifyTransfer;
exports.asperaSdk.createDropzone = core_1.createDropzone;
exports.asperaSdk.removeDropzone = core_1.removeDropzone;
exports.asperaSdk.getInstallerInfo = installer_1.getInstallerInfo;
exports.asperaSdk.registerStatusCallback = core_1.registerStatusCallback;
exports.asperaSdk.deregisterStatusCallback = core_1.deregisterStatusCallback;
exports.asperaSdk.registerSafariExtensionStatusCallback = core_1.registerSafariExtensionStatusCallback;
exports.asperaSdk.deregisterSafariExtensionStatusCallback = core_1.deregisterSafariExtensionStatusCallback;
exports.asperaSdk.initDragDrop = core_1.initDragDrop;
exports.asperaSdk.setBranding = core_1.setBranding;
exports.asperaSdk.getInfo = core_1.getInfo;
exports.asperaSdk.isSafari = helpers_1.isSafari;
var launch = exports.asperaSdk.globals.launch;
exports.launch = launch;
exports.asperaSdk.launch = launch;
if (typeof window === 'object') {
    window.asperaSdk = exports.asperaSdk;
}
exports.default = {
    isSafari: helpers_1.isSafari,
    init: core_1.init,
    testConnection: core_1.testConnection,
    startTransfer: core_1.startTransfer,
    launch: launch,
    registerActivityCallback: core_1.registerActivityCallback,
    deregisterActivityCallback: core_1.deregisterActivityCallback,
    removeTransfer: core_1.removeTransfer,
    showDirectory: core_1.showDirectory,
    stopTransfer: core_1.stopTransfer,
    resumeTransfer: core_1.resumeTransfer,
    getAllTransfers: core_1.getAllTransfers,
    getTransfer: core_1.getTransfer,
    registerRemovedCallback: core_1.registerRemovedCallback,
    deregisterRemovedCallback: core_1.deregisterRemovedCallback,
    showSelectFileDialog: core_1.showSelectFileDialog,
    showSelectFolderDialog: core_1.showSelectFolderDialog,
    showPreferences: core_1.showPreferences,
    modifyTransfer: core_1.modifyTransfer,
    createDropzone: core_1.createDropzone,
    removeDropzone: core_1.removeDropzone,
    getInstallerInfo: installer_1.getInstallerInfo,
    registerStatusCallback: core_1.registerStatusCallback,
    deregisterStatusCallback: core_1.deregisterStatusCallback,
    registerSafariExtensionStatusCallback: core_1.registerSafariExtensionStatusCallback,
    deregisterSafariExtensionStatusCallback: core_1.deregisterSafariExtensionStatusCallback,
    setBranding: core_1.setBranding,
    getInfo: core_1.getInfo,
};
